{
  "name": "invoice-manager",
  "version": "1.3.21",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-prod": "ng build --configuration production",
    "build-dev": "ng build --configuration development",
    "build:stats": "ng build --configuration production --stats-json",
    "analyze": "webpack-bundle-analyzer dist/invoice-manager/stats.json",
    "test": "ng test",
    "lint": "ng lint",
    "prebuild-patch": "npm --no-git-tag-version version patch",
    "prebuild-minor": "npm --no-git-tag-version version minor"
  },
  "private": true,
  "engines": {
    "node": "^22.12.0 || ^24.0.0",
    "npm": ">=9.0.0"
  },
  "dependencies": {
    "@angular/animations": "^22.0.6",
    "@angular/cdk": "^22.0.4",
    "@angular/common": "^22.0.6",
    "@angular/compiler": "^22.0.6",
    "@angular/core": "^22.0.6",
    "@angular/forms": "^22.0.6",
    "@angular/google-maps": "^22.0.4",
    "@angular/material": "^22.0.4",
    "@angular/platform-browser": "^22.0.6",
    "@angular/router": "^22.0.6",
    "@angular/service-worker": "^22.0.6",
    "@microsoft/applicationinsights-angularplugin-js": "^3.0.0",
    "@microsoft/applicationinsights-web": "^2.8.9",
    "@zxing/browser": "^0.2.1",
    "@zxing/library": "^0.23.0",
    "@zxing/ngx-scanner": "^22.0.1",
    "chart.js": "^3.9.1",
    "chartjs-adapter-date-fns": "^3.0.0",
    "chartjs-plugin-zoom": "^2.0.1",
    "date-fns": "^2.30.0",
    "fuse.js": "^7.0.0",
    "jwt-decode": "^4.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.0.0",
    "@angular-eslint/eslint-plugin": "^22.0.0",
    "@angular-eslint/eslint-plugin-template": "^22.0.0",
    "@angular-eslint/schematics": "^22.0.0",
    "@angular-eslint/template-parser": "^22.0.0",
    "@angular/build": "^22.0.5",
    "@angular/cli": "^22.0.5",
    "@angular/compiler-cli": "^22.0.6",
    "@angular/localize": "^22.0.6",
    "@eslint/eslintrc": "^3.3.5",
    "@eslint/js": "^10.0.1",
    "@types/node": "^20.14.0",
    "@typescript-eslint/eslint-plugin": "^8.63.0",
    "@typescript-eslint/parser": "^8.63.0",
    "angular-eslint": "^22.0.0",
    "eslint": "^10.6.0",
    "eslint-plugin-unused-imports": "^4.1.4",
    "istanbul-lib-instrument": "^6.0.3",
    "jsdom": "^29.1.1",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.63.0",
    "vitest": "^4.0.8",
    "webpack-bundle-analyzer": "^4.5.0"
  }
}
